import axios from 'axios';
import { useQuery } from 'react-query';
import {
  // dashboard location list
  ListFacilityLocationsOperationResponse,
  ListFacilityLocationsOptionalParams,
  ListReportsOperationResponse,
  // endorsers reports params
  ListReportsOptionalParams,
  SearchOperationResponse,
  // full search params
  SearchOptionalParams,
} from 'services/api/client/src';
import { HttpClient } from 'services/utils/security';
import { setGlobalHeaders } from 'services/utils/security/TokenCredential';
import { getVariableFromEnv } from 'utils/config';

const API_HOST_FD = getVariableFromEnv('API_HOST_FD');

const dashboardLocationList = async (
  params?: ListFacilityLocationsOptionalParams,
): Promise<ListFacilityLocationsOperationResponse> => HttpClient.listFacilityLocations(params);

/* get dashboard map locations query */
export const useLocationsList = (params?: ListFacilityLocationsOptionalParams) =>
  useQuery(['LocationsList', params], () => dashboardLocationList(params));

const fullSearchList = async (params?: SearchOptionalParams): Promise<SearchOperationResponse> =>
  HttpClient.search(params);

/* get full search list within app query */
export const useFullSearch = (params?: SearchOptionalParams) =>
  useQuery(['searchList', params], () => {
    if (params?.term !== '') {
      return fullSearchList(params);
    }
    return undefined;
  });

/* get all reports list for endorser */
const getEndorsersReportsList = async (
  params?: ListReportsOptionalParams,
): Promise<ListReportsOperationResponse> => HttpClient.listReports(params);

export const useGetEndorsersReports = (
  params?: ListReportsOptionalParams,
  endorserSide?: boolean,
) =>
  useQuery(['getEndorsersReports', params], () => getEndorsersReportsList(params), {
    enabled: endorserSide,
  });

/* query to check if user's in china */
const isUserInChina = async (): Promise<boolean> => {
  await setGlobalHeaders();
  const res = await axios.get(`${API_HOST_FD}/disableMaps`);
  return res.data;
};

export const useIsUserInChina = () => useQuery(['isUserInChina'], () => isUserInChina());
